'use strict';

angular.module('utils').factory('OCInsuranceUtil', function(
  CurrentUser,
  OCStringUtil,
  OpencareConstants,
) {
  const isOpencareStaff = () => CurrentUser.isImpersonated();

  return {

    isManagedProvider: (insuranceProvider) =>
      OpencareConstants.managedInsurance.providerNames.includes(insuranceProvider?.name),

    /**
     * Managed providers are read-only for US practice users only.
     * Insurance is a US-only feature, and Canadian practices keep editing everything themselves.
     */
    areManagedProvidersLocked: (doctor) => {
      if (isOpencareStaff()) {
        return false;
      }

      const isUSProvider = doctor?.providers?.some(
        (provider) => OCStringUtil.isUnitedStates(provider?.clinic?.address?.country),
      );

      if (isUSProvider) {
        return true;
      }

      // A doctor being set up has no providers yet, so fall back to the user's clinics
      // the same way OCCDoctorUtil.isInsuranceAvailable() does. getClinics() returns
      // undefined until the user is loaded, so guard before iterating.
      const userClinics = CurrentUser.getClinics();

      return Array.isArray(userClinics)
        && userClinics.some((clinic) => OCStringUtil.isUnitedStates(clinic?.address?.country));
    },

  };
});
